/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


/**
* A View for displaying lists.
*/
define([
    "backbone",
    "utils/string",
    "underscore",
  ], function(
    Backbone,
    StringUtils,
    _
  ) {
  var BaseEvent = _.extend({}, Backbone.Events, {
    trigger: function () {
      var args = arguments, that = this, currentEventName = args[0], matchedEvents = [];

      if (this._events) {
        _.forEach(Object.keys(this._events), function(eventName) {
          // E.g regex check if current event entity:anotation:mouseovers matches *:anotation:mouseovers
          var matched = StringUtils.matchString(currentEventName, eventName);
          // Original event is triggered always later.
          if (currentEventName !== eventName && matched) {
            matchedEvents.push(eventName);
          }
        });
      }

      // Trigger other found matching listeners. E.g entity:annotation:mouseover should triger also *:annotation:mouseover
      _.forEach(matchedEvents, function(eventName) {
        Backbone.Events.trigger.apply(that, [eventName, args[1]]);
      })
    
      // Trigger original listner
      Backbone.Events.trigger.apply(this, args);
    }
  });

  return BaseEvent;
});
